import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

/**
 * Styled span component for displaying informational notes
 */
const StyledNote = styled("span")(({ theme }) => ({
  fontSize: 12,
  textAlign: "center",
  color: "#888888",
  display: "block",
  [theme.breakpoints.only("xs")]: {
    marginTop: 20,
    fontSize: 10
  }
}));

/**
 * InfoNote component for displaying small informational text
 *
 * @component
 */
export const InfoNote = ({ text, className, ...props }) => {
  return (
    <StyledNote className={className} {...props}>
      {text}
    </StyledNote>
  );
};

InfoNote.propTypes = {
  /** Text content to display in the note */
  text: PropTypes.string.isRequired,
  /** Additional CSS class name */
  className: PropTypes.string,
  /** Any additional props to pass to the span element */
  props: PropTypes.object
};
